// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_3k1tf7dF","details-container":"_1HESBrie","subscription-list-item":"_2ZKkVsuG","title-container":"_208BfUn3","down-arrow":"_1vDyZy9F","rotate":"_1KhjFGoB","squared":"Hc1BEgJA","payment-list-item":"_3K-9f1rV","is-active":"NWpmrRWr","is-hidden":"_1ytlRclp","payment-list":"_2DAvrHSd","ora-fodaseee":"PhlVQiXH","payment-type":"_2iEgNDh3","succeeded":"_2gREuApH","active":"_2CYgKGMW","pending":"RPp_ugVg","declined":"_2C5dH6MM","expired":"NgUCEp-T","submitButton":"k3aq1Pye"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/SubscriptionDetails/SubscriptionDetails.styl
// module id = 552
// module chunks = 0